import React from "react";

export default function IconBilling({ size = 20, ...rest }) {
  return (
    <svg {...rest} width={size} height={size} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3333 5.00065V15.0007C18.3333 15.459 18.1701 15.8513 17.8437 16.1777C17.5173 16.5041 17.125 16.6673 16.6666 16.6673H3.33329C2.87496 16.6673 2.4826 16.5041 2.15621 16.1777C1.82982 15.8513 1.66663 15.459 1.66663 15.0007V5.00065C1.66663 4.54232 1.82982 4.14996 2.15621 3.82357C2.4826 3.49718 2.87496 3.33398 3.33329 3.33398H16.6666C17.125 3.33398 17.5173 3.49718 17.8437 3.82357C18.1701 4.14996 18.3333 4.54232 18.3333 5.00065ZM3.33329 6.66732H16.6666V5.00065H3.33329V6.66732ZM3.33329 10.0007V15.0007H16.6666V10.0007H3.33329Z" fill="currentColor"/>
    </svg>
  );
}
